export default __webpack_public_path__ + "static/media/covidfo.4c0d627c.png";